import { useQuery } from '@tanstack/react-query';
import { connectService } from 'v2/services/connect';

export const useLoadConnect = (connectId?: number) => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['connect', 'detail', connectId],
    queryFn: () => connectService.loadConnect(connectId!),
    enabled: !!connectId
  });

  return { connectData: data?.data ?? null, isLoading, error, refetch };
};
